module.exports = __webpack_public_path__ + "assets/images/CADUNFIT100.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/CADUNFIT100.png
// module id = 1332
// module chunks = 1